import { getAwsSecurityFindings } from './utils/alerts-api'
import { Panel } from './Panel'
import { PropsWithChildren } from 'react'

const SEVERITY_COLORS = {
  critical: 'text-red-500',
  high: 'text-amber-600',
  medium: 'text-yellow-500',
  low: 'text-gray-300',
  informational: 'text-gray-300',
} as const

export function AwsSecurityFindings() {
  return (
    <Panel
      title="AWS Security findings"
      getItems={getAwsSecurityFindings}
      getId={(item) => item.id}
      getGroup={(item) => item.severity}
      getGroupColor={(group) => SEVERITY_COLORS[group]}
      defaultGroup="critical"
      getRow={(item) => (
        <>
          <span className="w-[300px]">{item.productName}</span>
          <span className="flex-grow">{item.title}</span>
          <span>{item.account.name ?? item.account.id}</span>
        </>
      )}
      getDetails={(item) => (
        <div className="flex w-full flex-col gap-1 pl-10 px-4 py-2 border-b bg-lime-50">
          <Detail label="Summary">{item.summary}</Detail>
          {item.resource && (
            <Detail label="Resource">
              {item.resource.type} {item.resource.id}
            </Detail>
          )}
          {item.remedy && <Detail label="Remedy">{item.remedy}</Detail>}
          <span className="flex gap-4">
            {item.urls.issue && <ExternalLink href={item.urls.issue}>Issue</ExternalLink>}
            {item.urls.remedy && <ExternalLink href={item.urls.remedy}>Remediation</ExternalLink>}
          </span>
        </div>
      )}
    />
  )
}

function Detail({ label, children }: PropsWithChildren<{ label: string }>) {
  return (
    <div>
      <span className="font-semibold">{label}: </span>
      <span>{children}</span>
    </div>
  )
}
function ExternalLink({ href, children }: { href: string; children: string }) {
  return (
    <a target="_blank" rel="noreferrer" className="hover:bg-blue-100 underline" href={href}>
      {children}
    </a>
  )
}
